module.exports = __webpack_public_path__ + "static/media/filter.44dc370b.svg";